import { useEffect, useRef } from 'react';
import { Download } from 'lucide-react';
import { useDrawer } from '../DrawerSystem';
import ExportPanel from './ExportPanel';

/**
 * ExportDrawerTab — registers the "Lataa" tab in the drawer system.
 * Lets admins download the activity log view as JSON or Excel-compatible CSV.
 */
export default function ExportDrawerTab({ entries, total, activeInstanceId, categoryFilter, deviceFilter }) {
  const { registerTab, unregisterTab } = useDrawer();

  const contextRef = useRef({ entries, total, activeInstanceId, categoryFilter, deviceFilter });
  contextRef.current = { entries, total, activeInstanceId, categoryFilter, deviceFilter };

  useEffect(() => {
    registerTab({
      id: 'activity-log-export',
      label: 'Lataa',
      icon: <Download size={18} />,
      color: 'rgba(74, 158, 255, 0.3)',
      borderColor: 'rgba(74, 158, 255, 0.5)',
      order: 10,
      render: () => <ExportPanel contextRef={contextRef} />,
    });

    return () => unregisterTab('activity-log-export');
  }, [registerTab, unregisterTab]);

  return null;
}
